import EnumClass, { build } from '../EnumClass';
import data, { AttendanceStatusId, AttendanceStatusData } from './data';
import * as Translations from './translations';

export class AttendanceStatus extends EnumClass<AttendanceStatusId, AttendanceStatusData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: ATTENDANCE_STATUSES,
  getById: getAttendanceStatusById,
  marshaller: AttendanceStatusMarshaller,
} = build<AttendanceStatusId, AttendanceStatusData, AttendanceStatus>('AttendanceStatusEnum', data, AttendanceStatus);
